import React, { useState } from 'react';
import Header from './components/Header'
import Description from "./components/Description";
import Form from "./components/Form";
import Advantages from "./components/Advantages";
import Modal from "./components/Modal";
import translations from './translations'
//import {initAnalytics, AmplitudeWrapper} from './Analytics'
import Footer from "./components/Footer";
import './App.scss';

const LEGAL_DATA = {
    'common': {
        entity: 'Cognicate',
        name: 'Brightleap Inc.',
        address: '64 E. Broadway Rd, Suite 200 \n' +
            'Tempe, AZ 85282, US',
        email: 'support@cognicate.ac',
        phoneNumber: '+1 (775) 368-3582',
        support: '+1 (844) 460-4735'
    },
    'cogniapp.app': {
      entity: 'GrowityLTD',
      name: 'Growity Tech Ltd',
      address: 'Aglantzias, 21B, 2nd floor, office 1, \n' +
        'Aglantzia, 2108, Nicosia, Cyprus',
      email: 'support@cognicate.ac',
      phoneNumber: '+1 (775) 368-3582',
      support: '+1 (844) 460-4735'
    },
    'cogniapp.online': {
      entity: 'GrowityLTD',
      name: 'Growity Tech Ltd',
      address: 'Aglantzias, 21B, 2nd floor, office 1, \n' +
        'Aglantzia, 2108, Nicosia, Cyprus',
      email: 'support@cognicate.ac',
      phoneNumber: '+1 (775) 368-3582',
      support: '+1 (844) 460-4735'
    },
    'cogniapp.live': {
      entity: 'GrowityLTD',
      name: 'Growity Tech Ltd',
      address: 'Aglantzias, 21B, 2nd floor, office 1, \n' +
        'Aglantzia, 2108, Nicosia, Cyprus',
      email: 'support@cognicate.ac',
      phoneNumber: '+1 (775) 368-3582',
      support: '+1 (844) 460-4735'
    },
};

//initAnalytics();

function App() {
    const host = window.location.host;
    const legalDataByHost = LEGAL_DATA[host] || LEGAL_DATA['common'];
    //const legalName = legalDataByHost.entity;

    /*useEffect(()=> {
        AmplitudeWrapper('billTicketOpen', {
            result: legalName,
        });
    }, []);*/

    const [isShowModal, toggleModal] = useState(false);
    const [language, setLanguage] = useState('eng');

    const handleChangeLanguage = (lang) => {
        setLanguage(lang);
    };

    return (
        <div className="app">
            <div className="app_container">
            <Header
                language={language}
                cb={handleChangeLanguage}
            />
            <Description
                translations={translations[language]}
            />
            <Form
                toggleModal={toggleModal}
                translations={translations[language]}
            />
            <Advantages
                translations={translations[language]}
            />
            <Modal
                isShowModal={isShowModal}
                toggleModal={toggleModal}
                translations={translations[language]}
            />
            <Footer
                data={legalDataByHost}
            />
            </div>
        </div>
    );
}

export default App;
